var _g, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgExamSetCurriculumAdd = function SvgExamSetCurriculumAdd(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 3.77109V14.9711C14 15.9711 13.2 16.7711 12.2 16.7711H1.8C0.8 16.7711 0 15.9711 0 14.9711V3.77109C0 2.87109 0.4 2.17109 1 1.57109C1.5 1.17109 2.2 0.871094 3 0.871094H11C12.7 0.871094 14 2.17109 14 3.77109Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6004 16.1713H1.70039C1.00039 16.1713 0.400391 15.5713 0.400391 14.8713C0.400391 14.1713 1.00039 13.5713 1.70039 13.5713H14.0004V14.6713C14.0004 15.4713 13.4004 16.1713 12.6004 16.1713Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.40039 15.0707V16.6707C3.40039 16.7707 3.60039 16.8707 3.70039 16.8707L4.90039 16.2707L6.10039 16.8707C6.20039 16.9707 6.40039 16.8707 6.40039 16.6707V15.0707C6.40039 15.0707 6.40039 14.9707 6.30039 14.9707L3.40039 15.0707C3.40039 14.9707 3.40039 14.9707 3.40039 15.0707Z",
    fill: "#FFDB59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3.77109V12.8711H2.2C1.6 12.8711 1 12.3711 1 11.6711V1.57109C1.5 1.17109 2.2 0.871094 3 0.871094H11C12.7 0.871094 14 2.17109 14 3.77109Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8 8.87148H4.2C3.8 8.87148 3.5 8.47148 3.5 8.07148V4.57148C3.5 4.17148 3.8 3.77148 4.3 3.77148H10.9C11.3 3.77148 11.7 4.07148 11.7 4.57148V8.07148C11.6 8.47148 11.2 8.87148 10.8 8.87148Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 5.37109C4.5 5.07109 4.7 4.87109 5 4.87109H10.1C10.4 4.87109 10.6 5.07109 10.6 5.37109C10.6 5.67109 10.4 5.87109 10.1 5.87109H5C4.7 5.87109 4.5 5.57109 4.5 5.37109Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 7.37109C4.5 7.07109 4.7 6.87109 5 6.87109H10.1C10.4 6.87109 10.6 7.07109 10.6 7.37109C10.6 7.67109 10.4 7.87109 10.1 7.87109H5C4.7 7.87109 4.5 7.67109 4.5 7.37109Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9996 13.6707C15.9996 15.4707 14.4996 16.8707 12.7996 16.8707C11.0996 16.8707 9.59961 15.3707 9.59961 13.6707C9.59961 11.9707 11.0996 10.4707 12.7996 10.4707C14.4996 10.4707 15.9996 11.8707 15.9996 13.6707Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3994 14.1707H10.9994C10.6994 14.1707 10.3994 13.8707 10.3994 13.5707C10.3994 13.2707 10.6994 12.9707 10.9994 12.9707H14.3994C14.6994 12.9707 14.9994 13.2707 14.9994 13.5707C14.9994 13.8707 14.6994 14.1707 14.3994 14.1707Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1992 15.2705V11.8705C12.1992 11.5705 12.4992 11.2705 12.7992 11.2705C13.0992 11.2705 13.3992 11.5705 13.3992 11.8705V15.2705C13.3992 15.5705 13.0992 15.8705 12.7992 15.8705C12.3992 15.7705 12.1992 15.5705 12.1992 15.2705Z",
    fill: "url(#paint7_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 14.3273,
    y1: 2.11299,
    x2: -6.5034,
    y2: 22.1426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 7.47589,
    y1: 12.1084,
    x2: 6.94229,
    y2: 17.4448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90EFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3663F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 11.7443,
    y1: 0.832074,
    x2: -10.0518,
    y2: 33.8375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 7.4982,
    y1: 4.15718,
    x2: 7.5869,
    y2: 19.8577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B53F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 3.7182,
    y1: -0.990206,
    x2: 8.4296,
    y2: 6.86209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46227"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 2.8293,
    y1: -0.456906,
    x2: 7.5407,
    y2: 7.39539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46227"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 9.92621,
    y1: 14.1181,
    x2: 15.3034,
    y2: 13.0819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006FAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 10.8277,
    y1: 10.9969,
    x2: 13.7262,
    y2: 14.8842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006FAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.871094)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExamSetCurriculumAdd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ExamSetCurriculumAdd.132f22b2.svg";
export { ForwardRef as ReactComponent };